import { useState, useCallback } from 'react';
import API from 'api/api';
import { useFirebaseAuth } from 'domains/auth/hooks/useFirebaseAuth';

export default function useAddDriver() {
  const { uid } = useFirebaseAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const addDriver = useCallback(
    async (item) => {
      if (!uid) {
        setError(new Error('User not authenticated.'));
        return;
      }
      setLoading(true);
      setError(null);
      setSuccess(false);

      try {
        await API.post(`/users/${uid}/driver`, item);
        setSuccess(true);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [uid]
  );

  return { addDriver, loading, error, success };
}
